module.exports = __webpack_public_path__ + "img/inboxaware-logo.f6cf9e9e.svg";